import { Route, Routes } from "react-router-dom";
import axios from "axios";
import createStore from "react-auth-kit/createStore";
import AuthProvider from "react-auth-kit/AuthProvider";
import RequireAuth from '@auth-kit/react-router/RequireAuth'
import Site from "./Layouts/Site/Site";
import Admin from "./Layouts/Admin/Admin";
import Login from "./Layouts/Auth/Login";
import { API_URL } from "./Constants";
import { SingleBook } from "./Pages/Site/Mybooks/SingleBook";
import { useNetworkState } from "@uidotdev/usehooks";
import { Mybooks } from "./Pages/Site/Mybooks/Mybooks";
import { SavingLoaderProvider } from "./Components/SavingLoader/SavingLoader";

// import bgimg from './assets/bg2.jpg'
import bgimg from './assets/bg1.avif'

function App() {
    let internetConnection = useNetworkState();
    let token = localStorage.getItem("_auth")
    axios.defaults.baseURL = API_URL
    axios.defaults.headers.common.Authorization = "Bearer " + token
    const store = createStore({
        authName: '_auth',
        authType: 'localStorage',
    });

    return (
        <div style={{ backgroundImage: `url(${bgimg})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
            {internetConnection.online
                ? <AuthProvider store={store}>
                    <SavingLoaderProvider>
                        <Routes>
                            <Route path="/*" element={<Site />} />
                            <Route path="/mybook/:id" element={<SingleBook />} />
                            <Route path="/login" element={<Login />} />
                            <Route path={'/dash/*'} element={
                                <RequireAuth fallbackPath={'/'}>
                                    <Admin />
                                </RequireAuth>
                            }
                            />
                        </Routes>
                    </SavingLoaderProvider>
                </AuthProvider>
                : <Routes>
                    <Route path="/*" element={<Mybooks />} />
                    <Route path="/mybook/:id" element={<SingleBook />} />
                </Routes>
            }
        </div>
    );
}

export default App;
